import Container from 'Components/Container';
import ContentDetail from 'Components/Content/ContentDetail';
import ContentMenu from 'Components/Content/ContentMenu';
import Error from 'next/error';
import Head from 'next/head';
import Layout from 'Components/Layout';
import NavBackButton from 'Components/Headers/NavBackButton';
import { STATIC_PAGE_QUERY } from 'Queries/CONTENT';
import client from 'Lib/ApolloClient';
import { content_wrapper } from 'Styles/modules/content-page.module.scss'
import { getMenuItems } from 'utils/menu';
import isEmpty from 'utils/isEmpty';
import { useRouter } from 'next/router';

export default function ContentPage({ pageContent, menu }) {
  // const { title = '', content = '' } = pageContent;
  const router = useRouter();

  if (!router.isFallback && isEmpty(pageContent?.title)) {
    return <Error statusCode={404} />;
  }

  return (
    <Layout isFooter>
      <Head>
        <title>{pageContent?.title }</title>
      </Head>
      <div className="top-fix nav-wrapper normal-nav-wrapper lg:hidden">
        <NavBackButton isBackToHomepage />
        <h1 className="flex-1 text-center">{pageContent?.title }</h1>
      </div>

      <Container className={content_wrapper}>
        <ContentMenu menuItems={getMenuItems(menu)} menuTitle="Chính sách & điều khoản" />
        <ContentDetail content={pageContent} />
      </Container>

    </Layout>
  );
}

export async function getStaticProps(context) {
  const {
    params: { id }
  } = context;

  const { data } = await client.query({
    query: STATIC_PAGE_QUERY,
    variables: { id },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache'
  });

  return {
    props: {
      pageContent: data?.page || null,
      menu: data?.menu?.menuItems?.nodes || null
    }
  };
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking'
  };
}
